import React, { useEffect } from "react";
import Logo from "asset/image/hr-logo.png";
import "./404-style.css";
import { useDispatch } from "react-redux";
import { setFooterShow } from "features/homepage/homeDataSlice";

const ErrorPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setFooterShow(true));

    const redirectTimer = setTimeout(() => {
      window.location.href = '/';
    }, 5000);

    return () => clearTimeout(redirectTimer);
  }, [dispatch]);

  return (
    <>
      <div className="error-outer">
        <div id="error-page">
          <div className="content">
            <a href="/" className="logo">
              {/* <img src={Logo} alt='' /> */}
            </a>
            <h2 className="header" data-text="404">
              404
            </h2>
            <h4 data-text="Opps! Page not found">Oops! Page not found</h4>
            <p>
              Sorry, the page you are looking for doesnot exist. If you think
              something is broken, report a problem.
            </p>
            <div className="btns">
              <a href="/">return home</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ErrorPage;
